// Keep channel identity separate from the programme shown in the EPG.
export function playbackIdentity(content = {}, channel = {}) {
  const category = String(content.category || '').toUpperCase();
  const objectType = String(content.objecttype || '').toUpperCase();
  const replay = objectType === 'EPGPROGRAMME' && category === 'TVCHANEL';
  const restart = content.isRestart === true || content.isStartOver === true;
  const title = content.defaulttitle || content.title || content['display-name'] || '';
  const channelId = content.channelid || (objectType === 'CHANEL' ? content.objectid : '') || channel.objectid || '';
  const matchingChannel = channelId && String(channel.objectid) === String(channelId) ? channel : {};

  const epgProgramId = content.programmeid || content.epgprogram_id || content.program_id || (replay ? content.objectid : '') || content.program?.programmeid || content.program?.objectid || content.program?.id || '';
  const epgProgramTitle = replay ? title : (content.program?.title || content.program?.defaulttitle || content.program_title || '');
  const contentProvider = content.content_provider || content.contentprovider || content.provider || content.partnerid || content.partner_id || '';
  const profileId = content.profile_id || content.profileid || '';

  return {
    content_type: restart ? 'RESTART' : (replay ? 'REPLAYTV' : (category || objectType)),
    content_id: String(restart ? channelId : (replay ? epgProgramId || content.objectid || '' : content.objectid || '')),
    content_title: String(restart
      ? (content.channeltitle || content.channelname || matchingChannel.defaulttitle || matchingChannel.title || (objectType === 'CHANEL' ? title : ''))
      : (replay ? (epgProgramTitle || title) : title)),
    ...(profileId ? { profile_id: String(profileId) } : {}),
    program_id: String(epgProgramId || ''),
    program_title: String(epgProgramTitle || ''),
    content_provider: String(contentProvider || ''),
    ...(restart ? { action_name: 'RESTART', action: 'RESTART' } : {})
  };
}

export function finiteSeconds(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
}

// Elapsed playing time, independent of playhead position, seeks and live timestamps.
export class PlaybackWatchSession {
  constructor(content, now = () => performance.now()) {
    this.content = { ...content };
    this.now = now;
    this.startedAt = null;
    this.elapsed = 0;
    this.played = false;
    this.finished = false;
  }
  play() {
    if (this.finished || this.startedAt !== null) return;
    this.played = true;
    this.startedAt = this.now();
  }
  pause() {
    if (this.startedAt === null) return;
    this.elapsed += Math.max(0, this.now() - this.startedAt);
    this.startedAt = null;
  }
  finish() {
    if (this.finished) return null;
    this.pause();
    this.finished = true;
    if (!this.played) return null;
    return { ...this.content, watch_time: Math.round(this.elapsed) / 1000, view_count: 1 };
  }
}
